"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var MsbMobile =
/** @class */
function (_super) {
  __extends(MsbMobile, _super);

  function MsbMobile(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      isSegmentOpen: false
    };
    return _this;
  }

  MsbMobile.prototype.render = function () {
    var _this = this;

    var isSegmentOpen = this.state.isSegmentOpen;
    var _a = this.props,
        contentIncludesData = _a.contentIncludesData,
        openPath = _a.openPath,
        className = _a.className,
        onBackClick = _a.onBackClick,
        mobileQuickLinks = _a.mobileQuickLinks,
        segmentTree = _a.segmentTree,
        activeSegment = _a.activeSegment,
        metaTree = _a.metaTree,
        children = _a.children,
        openRootItem = _a.openRootItem;
    return React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "msbmobile", className])
    }, React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header", isSegmentOpen && "segment-open"])
    }, openPath && openPath.length > 0 && React.createElement(React.Fragment, null, React.createElement("a", {
      onClick: onBackClick,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-icon", CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-back-button"])
    }, React.createElement(Icon_1.Icon, {
      name: "i_110"
    })), React.createElement("a", {
      className: CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-headline",
      href: openRootItem.href,
      onClick: openRootItem.onClick,
      target: openRootItem.target
    }, openRootItem.label)), !openPath || openPath.length === 0 && React.createElement(React.Fragment, null, React.createElement("a", {
      className: CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-headline",
      href: contentIncludesData.logoDataUrl.url
    }, segmentTree.filter(function (item) {
      return !item.noMobile;
    }).filter(function (item) {
      return item.targetValue === activeSegment;
    }).map(function (segment) {
      return segment.label;
    })), React.createElement("a", {
      onClick: function onClick() {
        return _this.setState(function (oldState) {
          return {
            isSegmentOpen: !oldState.isSegmentOpen
          };
        });
      },
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-icon", CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-header-sparten-toggle", isSegmentOpen && "open"])
    }, React.createElement(Icon_1.Icon, {
      name: "i_997"
    })))), React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-segment", isSegmentOpen && CSSPrefix_1.lsgPre + "header-legacy-segment__open"])
    }, React.createElement("ul", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-segment-branch"])
    }, segmentTree.filter(function (item) {
      return !item.noMobile;
    }).map(function (segment) {
      return React.createElement("li", {
        className: segment.targetValue === activeSegment ? "active" : undefined
      }, React.createElement("a", {
        href: segment.href,
        onClick: segment.onClick,
        target: segment.target
      }, segment.label, segment.targetValue === activeSegment && React.createElement(Icon_1.Icon, {
        name: "i_113"
      })));
    })), React.createElement("ul", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-segment-meta"])
    }, metaTree.filter(function (item) {
      return !item.noMobile;
    }).map(function (meta) {
      return React.createElement("li", null, React.createElement("a", {
        href: meta.href,
        onClick: meta.onClick,
        target: meta.target
      }, meta.label));
    }))), children, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-login"
    }, React.createElement("a", {
      className: "b-a-04"
    }, React.createElement(Icon_1.Icon, {
      name: "legacy_lock"
    }), "Anmelden")), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-quicklinks"
    }, mobileQuickLinks.map(function (mobileQuicklink) {
      return React.createElement("a", {
        className: CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-quicklinks-link",
        href: mobileQuicklink.href,
        onClick: mobileQuicklink.onClick,
        target: mobileQuicklink.target
      }, mobileQuicklink.label);
    })));
  };

  return MsbMobile;
}(React.Component);

exports.MsbMobile = MsbMobile;